<template>
    <single-select :config="config" :key="config.storeField"></single-select>
</template>
<script>
    import SingleSelect from '../template/SingleSelect';

    export default {
        components: {SingleSelect},
        data: function () {
            return {
                config: {
                    question: 'Would you like to update your medical records release authorization?',
                    options: [
                        'Yes',
                        'No'
                    ],
                    storeField: 'update_medical_records_question',
                    clickBack: function () {
                        this.$router.go(-1)
                    }.bind(this),
                    clickContinue: async function (value) {
                        if (value === 'Yes') {
                            // Go to medical records release question where they can choose to authorize or not
                            await this.$router.push('/reg/medicalRecordsRelease')
                        } else {
                            await this.$router.push('/reg/bhBackground')
                        }
                    }.bind(this)
                }
            }
        }
    }
</script>

